module.exports = __webpack_public_path__ + "img/map-m.1c495f5.svg";